import { Component, Output, EventEmitter, Input } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { TokenTemplates } from "../../models/card.model";

@Component({
  selector: "app-token",
  templateUrl: "./token.component.html",
  styleUrls: ["./token.component.scss"]
})
export class TokenComponent {
  @Output()
  dragStartTokenEvent: EventEmitter<boolean> = new EventEmitter();

  @Input()
  template: string; // todo type

  @Input()
  cardTokens: any; // TODO type {key; string, value: number}

  @Output()
  changeCounterEvent: EventEmitter<any> = new EventEmitter();

  counterChange: boolean = false; // to display + and -

  toggleCounterChange() {
    if (this.template !== "EMPTY") {
      this.counterChange = !this.counterChange;
    }
  }

  debouncer: Subject<any> = new Subject<any>();

  constructor() {
    this.debouncer.pipe(debounceTime(1000)).subscribe(value => {
      this.changeCounterEvent.emit({ template: this.template, value: 0 });
    });
  }

  changeCounter(value) {
    this.cardTokens[this.template] += value;
    this.debouncer.next(value);
  }

  changeStringCounter() {
    this.changeCounterEvent.emit({
      template: this.template,
      value: this.tokenValue() * -1
    });
  }

  isStringTemplate() {
    return [
      TokenTemplates.STUNT,
      TokenTemplates.ENRAGE,
      TokenTemplates.WARD
    ].includes(this.template as TokenTemplates);
  }

  tokenTemplate() {
    if (this.template === undefined) {
      return "empty";
    }
    let isCounter = !this.tokenValue() || this.tokenValue() <= 0 ? "zero " : "";
    return isCounter + this.template; // 'marvel-coin';
  }

  tokenValue() {
    let result = 0;
    if (this.cardTokens && this.template) {
      return this.cardTokens[this.template];
    }
    return result;
  }
}
